import get from 'lodash/get';

import { ABOUT_MODAL_REDUCER_KEY } from './AboutModal.reducer';
import { Versions } from './AboutModal.types';

export function isAboutModalVisible(store: any): boolean {
	return get(store, ['inventory', ABOUT_MODAL_REDUCER_KEY, 'aboutModalVisible'], false);
}

export function getAboutModalServices(store: any): Versions {
	return get(store, ['inventory', ABOUT_MODAL_REDUCER_KEY, 'services'], {});
}
